import { BUSINESS_ACTVITY_TYPE_MAP } from "../../features/application/constants/business-activity-type.enum";
import { IndividualDocumentType } from "../../shared/models/individual.model";
import { CompanyType } from "../constants/company-type.enum";

export class MessageHelper {
    private static verifyDoesMapContainsKey(key: string, messageMap: Map<string, any>): void {
        if (!messageMap.has(key)) {
            throw new Error('There is no status defined like ' + key);
        }
    }
    
    static months = [
        '',
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

    static GetTextForDayAndMonth(day: number, year: number): string {
        return `${day} ${this.months[year]}`;
    }

    static getCompanyTypeText(type: string): string | null {
        this.verifyDoesMapContainsKey(type, COMPANY_TYPE_TEXT_MAP);
        return COMPANY_TYPE_TEXT_MAP.get(type) ?? null;
    }

    static getIndividualDocumentTypeText(type: IndividualDocumentType): string | null {
        // this.verifyDoesMapContainsKey(type, INDIVIDUAL_DOCUMENT_TYPE_TEXT_MAP);
        return INDIVIDUAL_DOCUMENT_TYPE_TEXT_MAP.get(type) ?? null;
    }

    static getStatusMessage(status: string): string | null {
      this.verifyDoesMapContainsKey(status, STATUS_MESSAGE_MAP);
      return STATUS_MESSAGE_MAP.get(status) ?? null;
    }

    static getStatusDescription(status: string): string | null {
      return STATUS_MESSAGE_DESC_MAP.get(status) ?? null;
    }

    static getApplicationTypeMessage(type: number): string | null {
      return APPLICATION_TYPE_MAP.get(type) ?? null;
    }

    static getBusinessActivityTypeText(type: number): string | null {
      return BUSINESS_ACTVITY_TYPE_MAP.get(type) ?? null;
    }

    static getEntityStatusText(type: string): string | null {
      return ENTITY_STATUS_MAP.get(type) ?? null;
    }

    
}

const COMPANY_TYPE_TEXT_MAP: Map<string, string> = new Map([
    [CompanyType.PRC, 'Private Company'],
    [CompanyType.PUC, 'Public Company'],
    [CompanyType.SPC, 'Special Purpose Company'],
    [CompanyType.PRI, 'Private Investment Company'],
    [CompanyType.PUI, 'Public Investment Company'],
    [CompanyType.GPA, 'General Partnership'],
    [CompanyType.LLP, 'Limited Liability Partnership'],
    [CompanyType.LPA, 'Limited Partnership'],
    [CompanyType.RCO, 'Recognised Company'],
    [CompanyType.RLP, 'Recognised Limited Liability Partnership'],
    [CompanyType.RPA, 'Recognised Limited Partnership'],
    [CompanyType.RGP, 'Recognised General Partnership'],
    [CompanyType.NPI, 'Non-Profit Incorporated Organisation'],
    [CompanyType.FOU, 'Foundation'],
])

const INDIVIDUAL_DOCUMENT_TYPE_TEXT_MAP: Map<IndividualDocumentType, string> = new Map([
    [IndividualDocumentType.IDENTITY_CARD, 'ID card'],
    [IndividualDocumentType.PASSPORT, 'Passport'],
])

const STATUS_MESSAGE_MAP: Map<string, string> = new Map([
    ['IN_PROGRESS', 'In Progress'],
    ['WAITING_FOR_SUBMISSION', 'Waiting For Submission'],
    ['SUBMITTED', 'Submitted'],
    ['ACCEPTED', 'Accepted'],
    ['REJECTED', 'Rejected'],
    ['EXPIRED', 'Expired'],
    ['DECLINED', 'Declined'],
    ['DEACTIVATED', 'Deactivated'],
    ['UPDATE_REQUIRED', 'Update Required'],
    ['PAID', 'Paid'],
    ['PENDING', 'Pending'],
    ['AFSA_INVOICE', 'Not Paid'],
    ['WITHDRAW_IN_PROGRESS', 'Withdraw In Progress'],
    ['WITHDRAW_ACCEPTED', 'Withdraw Accepted'],
    ['WITHDRAW_REJECTED', 'Rejected'],
    ['WITHDRAW_DECLINED', 'Withdraw Declined'],
    ['WITHDRAWN', 'Withdrawn'],
    ['SUSPENDED', 'Suspended'],
    ['SUSPENSION_ACCEPTED', 'Suspension Accepted'], // remove later
    ['SUSPENSION_DECLINED', 'Suspension Declined'], // need to be removed later
    ['SUSPEND_REJECTED', 'Rejected'],
    ['SUSPENSION_IN_PROGRESS', 'Suspension In Progress'],
    ['REACTIVATION_ACCEPTED', 'Reactivation Accepted'],
    ['REACTIVATED', 'Reactivated'],
    ['REACTIVATION_REQUESTED', 'Reactivation Requested'],
    ['REACTIVATION_DECLINED', 'Reactivation Declined'],
    ['REACTIVATION_REJECTED', 'Reactivate Rejected'],
    ['REACTIVATION_IN_PROGRESS', 'Reactivation In Progress'],
    ['MODIFICATION_REJECTED', 'Rejected'],
    ['MODIFICATION_ACCEPTED', 'Modification Accepted'],
    ['CHANGE_REJECTED', 'Rejected'],
    ['CHANGED', 'Changed'],
    ['EXTENSION_REJECTED', 'Rejected'],
    ['EXTENDED', 'Accepted'],
    ['UNDER_ASSESSMENT', 'Under Assessment'],
    ['AWAITING_DECISION', 'Awaiting Decision'],
    ['LICENSE_TERMS_ACCEPTED', 'License terms Accepted'],
    ['LICENSE_TERMS_REJECTED', 'License terms Rejected'],
    ['CHECKING_COMPANY', 'Checking company'],
    ['REGISTERED', 'Registered'],
    ['VISA_ISSUED', 'Visa Issued'],
    ['APPROVED', 'Approved'],
    ['SENT_TO_MIGRATION_AUTHORITY', 'Sent to Migration Authority'],
    ['IN_PRINCIPAL_APPROVAL', 'In Principal Approval'],
    ['AWAITING_AUTHORISATION', 'Awaiting Authorisation'],
    ['AWAITING_FOR_BIN', 'Awaiting for Bin'],
    ['AUTHORIZED', 'Authorized'],
    ['MODIFIED_APPROVED_INDIVIDUALS', 'Modified Approved Individuals'],
    ['WITHDRAWN_APPROVED_INDIVIDUALS', 'Withdrawn Approved Individuals'],
    ['IN_PROCESS', 'Under Assessment'],
    ['IIN_OBTAINED', 'IIN obtained'],
    ['SENT_FOR_IIN_GENERATION', 'Sent for IIN generation'],
    ['ASSIGNED', 'Assigned'],
    ['CONFIRMED', 'Confirmed'],
    ['COMPLETED', 'Completed'],
    ['SUBMITTED_TO_APPLICANT', 'Submitted to Applicant'],
    ['NEW', 'NEW']
  ]);

const STATUS_MESSAGE_DESC_MAP: Map<string, string> = new Map([
  ['IN_PROGRESS', 'Dear applicant, please, complete your application.'],
  ['WAITING_FOR_SUBMISSION', 'Dear applicant, if the status of application does not change within 40 minutes, please contact our technical support digital@aifc.kz for assistance'],
  ['SUBMITTED', 'Dear applicant, your application has been successfully submitted. We will get back to you as soon as possible.'],
  ['ACCEPTED', 'Dear applicant, we are happy to inform you that Certificate of Incorporation was issued confirming the status of the AIFC Participant. The "Registered Entities" tab now reflects your status'],
  ['REJECTED', 'Dear applicant, events of application for registration was rejected. Please, check the reason of rejection in the communication module.'],
  ['EXPIRED', 'Dear applicant, Your application has been expired due to exceeded time-limit for updating application. Please note that registration fee is non-refundable.'],
  ['UPDATE_REQUIRED', 'Dear applicant, after initial review of your application, AFSA Office of the registrar of Companies has concluded that information provided in the application is incomplete for registration. Please visit Communication module for more details and resubmit your application']
]);

const APPLICATION_ABBR_TYPE_MAP: Map<number, string> = new Map([
    [1, 'REG'],
    [2, 'POST-REG'],
])

const APPLICATION_TYPE_MAP: Map<number, string> = new Map([
    [1, 'Registration'],
    [7, 'Post-Registration'],
])

const ENTITY_STATUS_MAP: Map<string, string> = new Map([
    ['ACTIVE', 'Active'],
    ['REGISTERED', 'Registered'],
])

